import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import {DigitalContractService} from "../../../../../../../core/services/digital-contract.service";
import {CommonService} from "../../../../../../../core/services/common.service";
import {ToastrService} from "ngx-toastr";
import { EnvService } from 'src/app/core/services/env.service';
import { LIMIT_SIZE } from 'src/app/core/constants/common';
import {DocumentService} from "../../../../../../../core/services/document.service";
import {TranslateService} from "@ngx-translate/core";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-view-contract',
  templateUrl: './view-contract.component.html',
  styleUrls: ['./view-contract.component.scss']
})
export class ViewContractComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  activeFile = 0;
  pdfSrc;
  filesName = [];
  filesNameHaveOrder = [];
  filesSrc = [];
  markPdf: any;
  language: string;
  BASE_URL = 'http://localhost:8091/api';
  authorization: any
  isAnonymous: boolean = false;
  isTerminate: boolean = false;
  tenantId: any = sessionStorage.getItem('tenantId')
  hashKey: any = sessionStorage.getItem('hashKey')
  contractIdAndContractEnterpriseIdEncode: any = sessionStorage.getItem('contractIdAndContractEnterpriseIdEncode')
  constructor(
    private digitalContractService: DigitalContractService,
    public commonService: CommonService,
    private documentService: DocumentService,
    private translateService:TranslateService,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<ViewContractComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private env: EnvService
  ) {
    this.isAnonymous = data.isAnonymous || false
    this.isTerminate = data.isTerminate || false
    this.language = localStorage.getItem('__language') || 'vi';
    dialogRef.disableClose = false;
    this.changeFile(0);
    // this.BASE_URL = env.is_private_app ? env.private_api_endpoint : env.public_api_endpoint;
    this.BASE_URL = this.env.is_private_app ? this.env.private_api_endpoint : this.env.public_api_endpoint;
    this.BASE_URL += '/file/view/digital/view-file';
    if(this.isAnonymous){
      const token = localStorage.getItem('token')
      if(token){
        this.authorization = {
          Authorization: `Bearer ${token}`
        }
      }
    } else {
      this.authorization = {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`
      }
    }
  }

  ngOnInit() {

  }

  ngAfterViewInit(){

  }

  onNoClick() {
    this.dialogRef.close()
  }

  async callApiWaterMark(){
    const currentFrame = document.getElementById('sample-iframe');
    if(currentFrame){
      currentFrame.remove()
    }

    // let a = this.mainFormAdd.value.contractAttachments[this.activeFile].id

    if(!this.isAnonymous){
      await this.documentService.getDocWithWaterMarkV2(this.data.idDocument,this.data.id[this.activeFile]).subscribe( async (response: any) => {
        if(await response){
          this.markPdf =  await this.commonService.readFileAsync(response);
        }
        // Create the Blob URL:
        const buffer = this.markPdf;
        const blob = new Blob([buffer], {
          type: 'application/pdf'
        });
        const objectURL = URL.createObjectURL(blob);

        // Create an iframe to demonstrate it:
        const iframe = document.createElement('iframe');
        iframe.id = 'sample-iframe';
        iframe.src = objectURL;
        document.body.appendChild(iframe);
        iframe.contentWindow.print();
        iframe.hidden = true
      },(error:HttpErrorResponse)=>{
        this.toast.error(this.translateService.instant('messages.notGetPdf'))
      });
    } else {
      await this.documentService.getDocWithWaterMarkAnonymousV2(this.data.idDocument,this.data.id[this.activeFile],this.tenantId,this.hashKey).subscribe( async (response: any) => {
        if(await response){
          this.markPdf =  await this.commonService.readFileAsync(response);
        }
        // Create the Blob URL:
        const buffer = this.markPdf;
        const blob = new Blob([buffer], {
          type: 'application/pdf'
        });
        const objectURL = URL.createObjectURL(blob);

        // Create an iframe to demonstrate it:
        const iframe = document.createElement('iframe');
        iframe.id = 'sample-iframe';
        iframe.src = objectURL;
        document.body.appendChild(iframe);
        iframe.contentWindow.print();
        iframe.hidden = true
      },(error:HttpErrorResponse)=>{
        this.toast.error(this.translateService.instant('messages.notGetPdf'))
      });
    }

  }

  isString(value) {
    return typeof value === "string";
  }
  private checkmatched(listFileName: string[], name: string) {
    const filenameSplit = name.split('.')
    const type = filenameSplit.pop();
    const fileName = filenameSplit.join('.');
    let fileNameConverted = fileName + '.' + type;
    let k = 1;
    if (listFileName.length > 0) {
      while (listFileName.includes(fileNameConverted)) {
        fileNameConverted = fileName + '(' + k + ').' + type;
        k++;
      }
    }


    return fileNameConverted;
  }
  async doPrintDigital() {

    //this.isLoading = true;
    if (this.data.attachments.length > 0) {
      this.blockUI.start();
      for (let file of this.data.attachments) {
        this.filesName.push(this.checkmatched(this.filesName, file.fileName));
        this.filesNameHaveOrder = [...this.filesName.map((fileName, index) => ({
          order: index,
          fileName: fileName
        }))];
        const type = file.fileName.split('.').pop();
        if (type === 'pdf') {
          const pdfSrc = await this.viewDocumentUploadNew(file.id, file.fileName, file.fileSize);
          this.filesSrc.push(pdfSrc);

          this.pdfSrc = this.filesSrc[0];
        } else {
          this.filesSrc.push('notPDF');
          this.pdfSrc = this.filesSrc[0];
        }
      }
      this.blockUI.stop();
    }

    const currentFrame = document.getElementById('sample-iframe');
    if(currentFrame){
      currentFrame.remove()
    }

    if(this.isTerminate){
      this.callApiWaterMark();
      return
    }
    if(this.isString(this.pdfSrc)){
      if(this.pdfSrc =='notPDF'){
        this.toast.error(this.translateService.instant('messages.notPdf'))
        return
      }else if(this.pdfSrc.includes('view/digital/view-file')&&this.data.attachments[this.activeFile].fileSize > LIMIT_SIZE){
         this.callApiWaterMark();
        return
      }
    }

    if(this.pdfSrc.byteLength == undefined||this.pdfSrc.byteLength == 0){
      this.toast.error(this.translateService.instant('messages.errorPdf'))
      return
    }

    this.pdfSrc = this.filesSrc[this.activeFile];
    const buffer = this.pdfSrc;
    const blob = new Blob([buffer], {
      type: 'application/pdf'
    });
    const objectURL = URL.createObjectURL(blob);

    // Create an iframe to demonstrate it:
    const iframe = document.createElement('iframe');
    iframe.id = 'sample-iframe';
    iframe.src = objectURL;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
    //this.isLoading = false;//
    iframe.hidden = true

  }
  async doPrint() {
    // if(this.document.status !==this.EnumContractStatus.FINISHED ||
    //   (this.document.isConfirmBCT==true && this.document.bctConfirmStatus !== this.EnumContractStatus.FINISHED) ){
    //   this.callApiWaterMark()
    // }else{
    //   const currentFrame = document.getElementById('sample-iframe');
    //   if(currentFrame){
    //     currentFrame.remove()
    //   }
    //   // this.printService.print();
    //   if(this.isString(this.pdfSrc)){
    //     if(this.pdfSrc =='notPDF'){
    //       this.toastr.error(this.translateService.instant('messages.notPdf'))
    //       return
    //     }else if(this.pdfSrc.includes('file/view/contract')&&this.document.mainContractAttachments[this.activeFile].fileSize > LIMIT_SIZE){
    //       this.callApiWaterMark();
    //       return
    //     }
    //   }
    //
    //   if(this.pdfSrc.byteLength == undefined||this.pdfSrc.byteLength == 0){
    //     this.toastr.error(this.translateService.instant('messages.errorPdf'))
    //     return
    //   }
    //   this.pdfSrc = this.listPdfSrc[this.document.mainContractAttachments[this.activeFile].path];
    //   const buffer = this.pdfSrc;
    //   const blob = new Blob([buffer], {
    //     type: 'application/pdf'
    //   });
    //   const objectURL = URL.createObjectURL(blob);
    //
    //   // Create an iframe to demonstrate it:
    //   const iframe = document.createElement('iframe');
    //   iframe.id = 'sample-iframe';
    //   iframe.src = objectURL;
    //   document.body.appendChild(iframe);
    //   iframe.contentWindow.print();
    //   iframe.hidden = true
    // }
  }
  openPDFByBrowser(id: string) {
    let downLoadAPI = this.isAnonymous ? this.digitalContractService.downloadContractFailAnonymous(id,this.tenantId,this.hashKey) : this.digitalContractService.downloadContractFail(id)
    downLoadAPI.subscribe(error => {
      if (error.success === false) {
        this.toast.error(error.message);
        return;
      }
      if (error) {
        let downLoadAPi : any
        if (this.isAnonymous) {
          downLoadAPi = this.digitalContractService.downloadContractAnonymous(id,this.tenantId,this.hashKey)
        } else {
          downLoadAPi = this.digitalContractService.downloadContract(id)
        }
        downLoadAPi.subscribe(res => {
          if (window.top.navigator.msSaveOrOpenBlob) {
            // Store Blob in IE
            window.top.navigator.msSaveOrOpenBlob(res, this.data.contractName + '.zip');
          } else {
            // Store Blob in others
            const tA = document.body.appendChild(document.createElement('a'));
            tA.href = window.URL.createObjectURL(res);
            tA.download = this.data.contractName + '.zip';
            tA.style.display = 'none';
            tA.click();
            tA.parentNode.removeChild(tA);
          }
        });
      }
    })
  }
  async changeFile(index: number) {
    const type = this.data.filesName[index].split('.').pop();
    if (type === 'pdf') {
      const pdfSrc = await this.viewDocumentUpload(this.data.id[index], this.data.filesName[index], this.data.listFileSize[index]);
      this.pdfSrc = pdfSrc;
    } else {
      this.pdfSrc = 'notPDF';
    }
    this.activeFile = index;
  }

  async viewDocumentUploadNew(id, fileName, size?) {
    let pdfSrc;
    if (!this.env.pdfViewFullDownload && size && size > LIMIT_SIZE) {
      pdfSrc = `${this.BASE_URL}/${id}`;
    } else {
      const res = this.isAnonymous ? (await this.digitalContractService.getContractFilesAnonymous(id, this.tenantId, this.hashKey).toPromise()) : (await this.digitalContractService.getContractFiles(id).toPromise());
      pdfSrc = await this.showPdf(res, fileName);
    }
    return pdfSrc;
  }
  async viewDocumentUpload(id, fileName, size) {
    this.BASE_URL = this.env.is_private_app ? this.env.private_api_endpoint : this.env.public_api_endpoint;
    if(!this.env.pdfViewFullDownload && size >= LIMIT_SIZE) {
      this.BASE_URL += '/file/view/digital/view-file';
    } else  {
      this.BASE_URL += this.isAnonymous ? '/anonymous/file/view/digital/view-file-by-id':  '/file/view/digital/view-file-by-id';
//       this.BASE_URL += '/file/anonymous/view/digital/view-file-by-id';
    }
    const pdfSrc = this.isAnonymous ? `${this.BASE_URL}/${id}/${this.tenantId}/${this.hashKey}` :  `${this.BASE_URL}/${id}`;
    return pdfSrc;
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  };

  async showPdf(blob: any, fileName: string) {
    const file = this.blobToFile(blob, fileName);
    const pdfSrc = await this.commonService.readFileAsync(file);
    return pdfSrc;
  }
}
